var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-link-page-back"},[_c('a',{staticClass:"link-page-back",attrs:{"href":_vm.getLinkPageBack}},[_vm._v("\n    "+_vm._s(_vm.trans.get('generals.page.back'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }